module.exports = __webpack_public_path__ + "img/l_d4.c2022459.png";